export default {
    createExamPaper: "/gateway/huilianOperation/examPapercs/createExamPaper", // 获取考试试卷

    createExamPaperQuestion:
        "/gateway/huilianOperation/examPaperQuestioncs/createExamPaperQuestion", // 获取考试试卷题目

    commitExamResult:
        "/gateway/huilianOperation/learningResultcs/commitExamResult", // 试卷答案提交
};



// WEBPACK FOOTER //
// ./src/safetyTrainingExam/api.js